import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin, { DateClickArg } from '@fullcalendar/interaction';
import { CalenderProps } from './Calender';
import { useTranslation } from 'react-i18next';
import { EventClickArg } from '@fullcalendar/core';
import multiMonthPlugin from '@fullcalendar/multimonth';

interface MultiMonthCalendarProps extends CalenderProps {
  duration?: number;
  isMonthsScrollable?: boolean;
  monthsViewDivider?: boolean;
  initialDate?: Date;
}
export default function MultiMonthCalendar({
  events,
  duration,
  onOpenDate,
  onOpenEvent,
  isMonthsScrollable = false,
  monthsViewDivider = false,
  initialDate,
}: MultiMonthCalendarProps) {
  const { t } = useTranslation();
  const handleDateClick = (arg: DateClickArg) => {
    if (onOpenDate) {
      onOpenDate(arg.date);
    }
  };

  const handleEventClick = (arg: EventClickArg) => {
    if (onOpenEvent) {
      onOpenEvent(arg);
    }
  };

  const calendarHeight = duration && !isMonthsScrollable ? `${duration * 150}vh` : undefined;
  const initialView = monthsViewDivider ? 'multiMonthYear' : 'dayGrid';
  const mainPlugin = monthsViewDivider ? multiMonthPlugin : dayGridPlugin;
  return (
    <FullCalendar
      initialView={initialView}
      plugins={[mainPlugin, interactionPlugin]}
      duration={{ months: isMonthsScrollable ? 3 : duration || 1 }}
      multiMonthMaxColumns={monthsViewDivider ? 1 : undefined}
      dateClick={handleDateClick}
      eventClick={handleEventClick}
      weekends={true}
      events={events}
      initialDate={initialDate || new Date()}
      locale={'he'}
      direction={'rtl'}
      buttonText={{
        today: t('global.calendar.today'),
      }}
      height={calendarHeight}
    />
  );
}
